module.exports = __webpack_public_path__ + "static/media/7-2.a17d9d97.mp3";